import { BookingPeriod } from '@spiaggeit/spit-datepicker'
import { t } from 'i18next'
import { useAppSelector } from '@/hooks/store.ts'
import { insertPeriodSlice } from '@/store/insertPeriodSlice.ts'
import { useFormattedDateRange } from '../../hooks/useFormattedDateRange.ts'

interface DateRangeProps {
  startDate: string
  endDate: string
}

export const DateRange = (props: DateRangeProps) => {
  const formattedDateRange = useFormattedDateRange(
    props.startDate,
    props.endDate
  )
  const bookingPeriod = useAppSelector(
    insertPeriodSlice.selectors.bookingPeriod
  )

  const isBookingPeriodHalfDay =
    bookingPeriod === BookingPeriod.MORNING ||
    bookingPeriod === BookingPeriod.AFTERNOON
  const bookingPeriodString = t(`datepicker.bookingPeriod.${bookingPeriod}`)

  return (
    <span aria-label={formattedDateRange.full} title={formattedDateRange.full}>
      {formattedDateRange.short}
      {isBookingPeriodHalfDay ? ` · ${bookingPeriodString}` : null}
    </span>
  )
}
